






import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';
import { TupleDictionary } from '@/utils/tupleDictionary';
import { ClientEnum } from '@/enums/client.enum';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import { VehicleTypeEnum } from '@/enums/vehicle-type.enum';

@Component({
  name: 'PbiGreenfieldPage',
  components: { ReportPowerBiContainer }
})
export default class PbiGreenfieldPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    // BRASIL
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Brasil], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '11886782-cfee-4e0a-ac40-c9e90b8611e9' });
    this.dictReports.set([ClientEnum.Volkswagen, VehicleTypeEnum.Car, CountryEnum.Brasil], { brand: 'VW', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '60171d13-d63a-4eba-bca3-3d29506a6561' });

    // BRASIL MOTO
    this.dictReports.set([ClientEnum['Royal Enfield'], VehicleTypeEnum.Motorcycle, CountryEnum.Brasil], { brand: 'Royal Enfield', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '87997010-9bc4-4b0e-a0e4-d0c8362293cc' });


    // COLOMBIA
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Colombia], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '6e039389-1a5e-4c3d-b3a6-b1ee48b1b87f' });
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Colombia], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '5d31b1d7-32de-43a9-9656-68e50e558d77' });

    // PERU
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Peru], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '00634c22-bf22-45e7-b2cf-2958ece8800d' });

    // EQUADOR
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Equador], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '67928b16-1f9e-46c9-9193-6612fab6143f' });

    // URUGUAI
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Uruguai], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '50ac8bae-5b98-4d4c-bfd5-388d66c1abd5' });

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Greenfield Solution`);
  }
}
